<script setup>
import { useHead } from '@unhead/vue';
import BrandForm from '../../scripts/components/contactForm/BrandForm.vue';
import CarouselGeneric from '../../scripts/components/CarouselGeneric.vue';

const imagesGlob = import.meta.glob('../../images/brands/allmade/products/*', { eager: true });

useHead({});

const products = [
	{
		title: "Allmade Unisex Tri-Blend Hoodie Tee", 
		src: imagesGlob["../../images/brands/allmade/products/swaggerproductpagewebsiteproductsallmadeunisex-triblend-hoodie-tee.png"].default
	},
	{
		title: "Allmade Unisex Organic French Terry Full-Zip Hoodie", 
		src: imagesGlob["../../images/brands/allmade/products/swaggerproductpagewebsiteproductsallmadeunisex-organic-french-terry-fullzip-hoodie.png"].default
	},
	{
		title: "Allmade Unisex Heavyweight Recycled Cotton Tee", 
		src: imagesGlob["../../images/brands/allmade/products/swaggerproductpagewebsiteproductsallmadeunisex-heavyweight-recycled-cotton-tee.png"].default
	},
	{
		title: "Allmade Unisex Long Sleeve Organic Cotton Tee", 
		src: imagesGlob["../../images/brands/allmade/products/swaggerproductpagewebsiteproductsallmadeunisex-long-sleeve-organic-cotton-tee.png"].default
	},
	{
		title: "Allmade Unisex Organic French Terry Pullover Hoodie", 
		src: imagesGlob["../../images/brands/allmade/products/swaggerproductpagewebsiteproductsallmadeunisex-organic-french-terry-pullover-hoodie.png"].default
	},
	{
		title: "Allmade Unisex Organic CVC Fleece Pullover Hoodie", 
		src: imagesGlob["../../images/brands/allmade/products/swaggerproductpagewebsiteproductsallmadeunisex-organic-cvc-fleece-pullover-hoodie.png"].default
	},
	{
		title: "Allmade Unisex Organic CVC Fleece Crewneck Sweatshirt", 
		src: imagesGlob["../../images/brands/allmade/products/swaggerproductpagewebsiteproductsallmadeunisex-organic-cvc-fleece-crewneck-sweatshirt.png"].default
	},
	{
		title: "Allmade Unisex Mineral Dye Organic Cotton Tee", 
		src: imagesGlob["../../images/brands/allmade/products/swaggerproductpagewebsiteproductsallmadeunisex-mineral-dye-organic-cotton-tee.png"].default
	},
	{
		title: "Allmade Unisex Long Sleeve Recycled Blend Tee", 
		src: imagesGlob["../../images/brands/allmade/products/swaggerproductpagewebsiteproductsallmadeunisex-long-sleeve-recycled-blend-tee.png"].default
	}
]

</script>

<template lang="pug">
.page.page--brand.allmade
	section.hero
		.hero__bg
		.hero__content
			.copy
				img(src='@static/images/brands/allmade/logo.png')
				h1 Custom Allmade
			.image
				img(src='@static/images/brands/allmade/hero.png' alt='A couple walks together outdoors, wearing Allmade T-shirts and casual pants, smiling in a scenic mountain setting.')
	section.section.section--subhero
		.section__content
			.copy
				h3 FEEL YOUR IMPACT
				p Allmade makes apparel that feels good in every way. From tees and tanks to hoodies and sweatshirts, every piece is crafted with people and the planet in mind. Their signature fabrics blend recycled polyester from plastic bottles, TENCEL™ Modal made from renewable trees, and organic cotton grown without harmful chemicals. The result is soft, long lasting gear that saves water, reduces waste, and lowers carbon emissions. Allmade makes it simple to create branded apparel that people actually want to wear while making a meaningful difference.

	.page__content
		section.section.section--products
			.section__content
				CarouselGeneric(name="productCarousel" :innerNav="false" :perPage="{ 0: 1, 751: 3 }")
					.product-card(v-for="product in products")
						.product-card__image
							img(:src="product.src")
						.product-card__text
							p {{product.title}}
							

		
		section.section.section--form
			.section__content
				h2 Love this brand?<br/>Let's make something cool together
				p Please fill out this form so we can help you with your upcoming project.
				.form-wrap
					BrandForm(formName="allmade")
		
		section.section.section--detail
			.stripe
				img(src='@static/images/brands/allmade/banner.jpg' alt='Gray clothing fabric with a white Allmade care tag showing origin and washing instructions.')
			.section__content
				.copy
					h2 BETTER FOR PEOPLE AND THE PLANET
					p Allmade proves that the clothes you choose can create real change. Every order helps divert plastic from oceans and landfills, conserve water, and support ethical manufacturing. Their retail quality garments are built for daily wear, designed for decoration, and made to last. Custom Allmade by Swagger sends a clear message that your brand cares about more than just looking good. It is comfortable, high quality gear with a conscience. The apparel looks good, feels good, and does good.
		
		section.section.section--foot
			.bg
			.section__content

</template>

<style></style>